import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import SQLDatabaseCalc from '../components/calculators/SQLDatabaseCalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function SQLDatabasePage() {
  return (
    <>
      <Helmet>
        <title>Azure SQL Database Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure SQL Database costs in GBP for UK South. Compare DTU vs vCore, Elastic Pool, Reserved Instances, Azure Hybrid Benefit, and the March 2026 Savings Plan." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/sql-database" />
        <meta property="og:title" content="Azure SQL Database Cost Calculator UK" />
        <meta property="og:description" content="DTU vs vCore pricing comparison for Azure SQL Database in UK South GBP — with Elastic Pool, AHB, Reserved Instances, and Savings Plan modelling." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/sql-database" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Azure SQL Database Calculator', url: '/sql-database', position: 2 },
        ]))}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure SQL Database Cost Calculator',
          description: 'Independent Azure SQL Database pricing calculator for UK South — compare DTU vs vCore with Elastic Pool, AHB, Reserved Instances, and Savings Plan (March 2026).',
          url: 'https://www.azure-calc.co.uk/sql-database',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure SQL Database Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · DTU vs vCore · Elastic Pool · Reserved Instances · Savings Plan
          </p>
        </div>

        <SQLDatabaseCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>Related guides</h2>
          <Link
            to="/guides/azure-sql-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold group-hover:text-[#0078d4] transition-colors" style={{ color: 'var(--text-secondary)' }}>Azure SQL Database Pricing Guide UK</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>DTU vs vCore explained, Elastic Pool break-even, AHB, Reserved Instances, and the March 2026 Savings Plan</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
